import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import eyeIcon from "../../../assets/images/app/allaya/eye-icon.svg";
import editIcon from "../../../assets/images/app/allaya/edit-icon.svg";
import deleteIcon from "../../../assets/images/app/allaya/delete-icon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/images/app/allaya/filter-autocomplete.svg";

import { SearchBox } from "../../../components/SearchBox";
import { CustomButton } from "../../../components/CustomButton";
import AudioFilterModal from "../AudioFilterModal";
import { FilterChips } from "../FilterChips";
import { transformFiltersToArray, truncateString } from "../../../utils/commonUtils";
import { DataTable } from "../../../components/DataTable";
import { LABELS } from "../Config";
import { UserStatus } from "../../../constants";
import SubscriptionStatus, { SUBSCRIPTION_STATUS } from "../../../constants/SubscriptionStatus";
import { APP_ROUTES, getParamsAttachedRoute } from "../../../helpers/routeHelpers";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest";
import {
    DeleteAlbum,
    GetSingleAudioListing,
    UpdateAudioStatusById
} from "../../../api/api.service";
import { Pagination } from "../../../components/Pagination";
import { USER_STATUS } from "../../../constants/UserStatus";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { showToast, SUCCESS } from "../../../utils/toastUtils";
import { ConfirmationModal } from "../../../components/CustomModal";
import CustomSwitchInput from "../../../components/Input/CustomSwitchInput";
import { findStatusChecked, getStatus } from "../utils";
import { MODAL_CONTENT_CONFIG } from "../ModalContentConfig";

let { AUDIO_TITLE, AUDIO_SUB_CATEGORIES, AUTHOR, NARRATOR, STATUS, AUDIO_TYPE, ACTION } = LABELS;
const CHARACTER_LIMIT = 30;
const recordUpdateSuccessMessage = "Status has been updated successfully";

const AudioShares = () => {
    const history = useHistory();
    const [isFilterModal, setIsFilterModal] = useState(false);
    const [filters, setFilters] = useState({
        subCategory: [],
        status: [],
        audioType: []
    });

    const [modalConfig, setModalConfig] = useState(null);
    const [selectedRecord, setSelectedRecord] = useState({ status: "", id: "" });
    const [isAudioStatusUpdating, setIsAudioStatusUpdating] = useState(false);

    const [isAudioDelete, setIsAudioDelete] = useState(false);
    const [audioID, setAudioID] = useState(null);

    const {
        isFetching,
        page,
        handlePageClick,
        total,
        data,
        searchText,
        limit,
        refetch,
        handleSearchChange,
        handleSortingChange
    } = useLocalPaginatedRequest({
        key: getKey([MODULE_KEYS.SINGLE_AUDIO_MANAGEMENT]),
        requestFn: GetSingleAudioListing,
        dataKey: "data",
        totalKey: "total",
        params: {
            categoryId: 4,
            ...(filters.status?.value && {
                status:
                    filters.status?.value == "Active" ? USER_STATUS.ACTIVE : USER_STATUS.INACTIVE
            }),
            ...(filters.audioType?.value && {
                tierType:
                    filters.audioType?.value == "Premium"
                        ? SUBSCRIPTION_STATUS.PREMIUM
                        : SUBSCRIPTION_STATUS.FREEMIUM
            }),
            ...(filters.subCategory?.length > 0 && {
                labelIds: filters.subCategory.map((item) => item?.value)
            })
        }
    });

    //  delete handling
    let { useMutate } = useRequestProcessor();

    let { mutate: audioUpdateMutate } = useMutate("", getKey(), (data) =>
        UpdateAudioStatusById({ Id: selectedRecord?.id, bodyData: data })
    );

    let { mutate, isLoading } = useMutate("", getKey(), () => DeleteAlbum(audioID));

    // Open filter modal
    const openFilterModal = () => setIsFilterModal(true);

    // Handle applying filters
    const handleApplyFilter = (newFilters) => {
        setFilters(newFilters);
        setIsFilterModal(false);
    };

    const handleRemoveFilter = (type, value) => {
        setFilters((prevFilters) => {
            // Create a new object to avoid mutating the state
            const updatedFilters = { ...prevFilters };

            // Handle arrays (like `subCategory`)
            if (Array.isArray(updatedFilters[type])) {
                updatedFilters[type] = updatedFilters[type].filter((item) => item.value !== value);
            }

            // Handle objects (like `status` or `audioType`)
            if (typeof updatedFilters[type] === "object" && updatedFilters[type] !== null) {
                if (updatedFilters[type].value === value) {
                    updatedFilters[type] = null; // Clear the object if the value matches
                }
            }

            return updatedFilters;
        });
    };

    const handleAudioStatusUpdate = () => {
        setIsAudioStatusUpdating(true);
        let statusToSet = getStatus(selectedRecord.status);

        const bodyData = { status: statusToSet };
        // Api call here
        audioUpdateMutate(bodyData, {
            onSuccess: async (res) => {
                setModalConfig(null);

                setIsAudioStatusUpdating(false);

                showToast(SUCCESS, recordUpdateSuccessMessage);

                refetch();
            },
            onError: (err) => {
                // showToast(ERROR, err?.Message)
                setIsAudioStatusUpdating(false);
            }
        });
    };

    const handleActionCancellation = () => {
        setModalConfig(null);
    };

    const handleActionInit = (id, status) => {
        setSelectedRecord({ id, status });
        let statusToSet = getStatus(status);
        setModalConfig(MODAL_CONTENT_CONFIG[statusToSet]);
    };

    const deleteClickHandler = (id) => {
        setAudioID(id);
        setIsAudioDelete(true);
    };

    const audioDeleteHandler = () => {
        mutate(
            {},
            {
                onSuccess: async (res) => {
                    setIsAudioDelete(false);
                    showToast(SUCCESS, "Audio has been deleted successfully");
                    refetch();
                },
                onError: (err) => {
                    console.log("not cerated", err);
                    setIsAudioDelete(false);
                }
            }
        );
    };

    return (
        <div>
            <Row className="pt-3 px-3">
                <Col sm="12" md="3" lg="3">
                    <SearchBox
                        className="w-100"
                        placeholder="Search & filter items"
                        value={searchText}
                        onChange={handleSearchChange}
                        icon={
                            <div className="pointer" onClick={openFilterModal}>
                                <FilterIcon />
                            </div>
                        }
                    />
                </Col>
                <Col sm="12" md="6" lg="6"></Col>
                <Col sm="12" md="3" lg="3" align="right">
                    <CustomButton
                        title="Add Story Audio"
                        color="primary"
                        icon={<i className="bx bx-plus"></i>}
                        className="custom-btn-lg"
                        onClick={() => history.push(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_ADD)}
                    />
                </Col>
            </Row>
            <Row className="px-3 my-2">
                <FilterChips
                    filters={transformFiltersToArray(filters)}
                    onRemove={handleRemoveFilter}
                />
            </Row>

            <DataTable
                tableContainerClass=""
                loading={isFetching}
                data={data}
                config={[
                    {
                        title: AUDIO_TITLE,
                        render: (data) => (
                            <div data-container={data?.title}>
                                {truncateString(data?.title, CHARACTER_LIMIT) || "-"}
                            </div>
                        )
                    },
                    {
                        title: AUDIO_SUB_CATEGORIES,
                        render: (data) => {
                            const labels = data?.albumLabels
                                ?.map((item) => item.label?.title)
                                .filter(Boolean)
                                .join(", ");
                            return (
                                <div data-container={labels}>
                                    {truncateString(labels, 30) || "-"}
                                </div>
                            );
                        }
                    },
                    {
                        title: AUTHOR,
                        render: (data) => (
                            <div data-container={data?.author?.name}>
                                {truncateString(data?.author?.name, CHARACTER_LIMIT) || "-"}
                            </div>
                        )
                    },
                    {
                        title: NARRATOR,
                        render: (data) => (
                            <div data-container={data?.narrator?.name}>
                                {truncateString(data?.narrator?.name, CHARACTER_LIMIT) || "-"}
                            </div>
                        )
                    },

                    {
                        title: STATUS,

                        render: (data) =>
                            (
                                <div className="mb-0 audio-status">
                                    <CustomSwitchInput
                                        label="Inactive"
                                        isChecked={findStatusChecked(data?.status, data?.fullName)}
                                        size="small"
                                        onClick={() => handleActionInit(data?.id, data?.status)}
                                    />
                                </div>
                            ) || "-"
                    },
                    {
                        title: AUDIO_TYPE,
                        render: (data) => (
                            <div
                                className={`status-common-class ${SubscriptionStatus.getLabelClass(
                                    data?.tierType
                                )}`}
                            >
                                {SubscriptionStatus.getDisplayTextKey(data?.tierType) || "-"}
                            </div>
                        )
                    },
                    {
                        title: ACTION,
                        render: (data) => {
                            return (
                                <div className="d-flex ">
                                    <img
                                        className="me-1"
                                        src={eyeIcon}
                                        alt={"view"}
                                        role="button"
                                        onClick={() => {
                                            const route = getParamsAttachedRoute(
                                                APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_DETAILS,
                                                { sharesID: data?.id }
                                            );

                                            history.push(route);
                                        }}
                                    />
                                    <img
                                        className="me-2"
                                        src={editIcon}
                                        alt={"edit"}
                                        role="button"
                                        onClick={() =>
                                            history.push(
                                                getParamsAttachedRoute(
                                                    APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_UPDATE,
                                                    {
                                                        sharesID: data?.id
                                                    }
                                                )
                                            )
                                        }
                                    />
                                    <img
                                        className="me-1"
                                        src={deleteIcon}
                                        alt={"delete"}
                                        role="button"
                                        onClick={() => deleteClickHandler(data?.id)}
                                    />
                                </div>
                            );
                        }
                    }
                ]}
            />

            <Pagination
                rowLimit={limit}
                onPageClick={handlePageClick}
                currentPage={page}
                totalData={total}
                handleChange={(e) => handleSortingChange(e.target.value)}
            />

            <AudioFilterModal
                isModalOpen={isFilterModal}
                handleClose={() => setIsFilterModal(false)}
                handleApplyFilter={handleApplyFilter}
                selectedFilters={filters} // Pass the current filters to the modal
            />

            <ConfirmationModal
                size="md"
                hasCustomConfig
                isOpen={modalConfig}
                customImageSrc={modalConfig?.imageSrc}
                customTitle={modalConfig?.modalTitle}
                customSubText={modalConfig?.modalSubText}
                customYesBtnText={modalConfig?.yesButtonText}
                customNoBtnText={modalConfig?.noButtonText}
                onYes={handleAudioStatusUpdate}
                onNo={handleActionCancellation}
                yesLoading={isAudioStatusUpdating}
            />

            <ConfirmationModal
                size="md"
                hasCustomConfig
                isOpen={isAudioDelete}
                customImageSrc={deleteIcon}
                customSubText={"Are you sure you want to delete this audio?"}
                customYesBtnText={"Delete"}
                customNoBtnText={"Cancel"}
                onYes={audioDeleteHandler}
                onNo={() => {
                    setIsAudioDelete(false);
                }}
                yesLoading={isLoading}
            />
        </div>
    );
};

export default AudioShares;
